import React from "react";

const title = "wms-logo";

export default function WMSImageLogo({ className }) {
  return <img src="wms-logo.png" alt={title} className={className} />;
}
